// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__jmwKI","balanceDisclaimer":"posDashboard_balanceDisclaimer__3mZFX"};